export interface CampaignUtm {
	utmSource: string
	utmMedium: string
	utmCampaign: string
}

// The query string alone - what goes in Meta's "URL parameters" / Google's "final URL suffix" fields.
export function buildUtmQuery(utm: CampaignUtm): string {
	return new URLSearchParams({
		utm_source: utm.utmSource,
		utm_medium: utm.utmMedium,
		utm_campaign: utm.utmCampaign,
	}).toString()
}

// Link to the website: the site with the UTM params (replacing any already in it).
export function buildSiteLink(siteUrl: string, utm: CampaignUtm): string {
	const url = new URL(siteUrl)
	for (const [key, value] of new URLSearchParams(buildUtmQuery(utm))) {
		url.searchParams.set(key, value)
	}
	return url.toString()
}

// UTM params of an app link: a visitor of the site may have no campaign (or only some of the params)
export type AppLinkUtm = Pick<CampaignUtm, 'utmSource'> & {
	utmMedium?: string | null
	utmCampaign?: string | null
}

// Link to the app through AppsFlyer's OneLink: AppsFlyer records the click and sends the visitor to their
// store (or opens the app), then reports `media_source` = pid and `campaign` = c on install - the same
// campaign name as the web link, so both land on the same stats row. Desktop visitors go to the site link.
export function buildAppLink(oneLinkUrl: string, utm: AppLinkUtm, siteLink: string): string {
	const url = new URL(oneLinkUrl)
	url.searchParams.set('pid', utm.utmSource)
	if (utm.utmCampaign) {
		url.searchParams.set('c', utm.utmCampaign)
	}
	if (utm.utmMedium) {
		url.searchParams.set('af_channel', utm.utmMedium)
	}
	url.searchParams.set('af_web_dp', siteLink)
	return url.toString()
}
